/**
 * App Detail Dialog Component - Wraps AppDetail in a Dialog
 */

import { useParams, useLocation } from 'wouter-preact';
import { Dialog } from './Dialog';
import { AppDetail } from './AppDetail';

export function AppDetailDialog() {
  const params = useParams<{ id?: string }>();
  const [, setLocation] = useLocation();

  const appId = params.id;

  const handleClose = () => {
    setLocation('/apps');
  };

  if (!appId) return null;

  return (
    <Dialog isOpen={true} onClose={handleClose} title={'App Details'}>
      <AppDetail appId={appId} />
    </Dialog>
  );
}
